module.exports = __webpack_public_path__ + "static/media/HealiaryPrivacyPolicy.c89cd572.txt";